/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToolsPliersWireStripperIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tools-pliers-wire-stripper"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.63 23.68Q5.95 22.45 5.71 20.84Q5.47 19.23 5.47 17.88Q5.47 15.32 6.08 13.64Q6.67 11.95 7.67 10.95L7.67 5.53L10.82 0.3L11.5 0.3L11.5 5.78Q11.25 5.9 11.13 6.13Q11 6.35 11 6.63Q11 7.05 11.29 7.34Q11.57 7.63 12 7.63Q12.43 7.63 12.71 7.34Q13 7.05 13 6.63Q13 6.35 12.88 6.13Q12.75 5.9 12.5 5.78L12.5 0.3L13.18 0.3L16.32 5.53L16.32 10.95Q17.32 11.95 17.93 13.64Q18.52 15.32 18.52 17.88Q18.52 19.43 18.24 20.99Q17.95 22.55 17.38 23.68Q16.1 23.23 15.34 22.4Q14.57 21.57 14.57 20.15Q14.57 19.43 14.72 18.75Q14.88 18.07 14.88 17.35Q14.88 16.1 14.11 14.57Q13.35 13.05 12 11.55Q10.65 13.05 9.89 14.57Q9.13 16.1 9.13 17.35Q9.13 18.07 9.28 18.75Q9.43 19.43 9.43 20.13Q9.43 21.32 8.66 22.31Q7.9 23.3 6.63 23.68Z" fill={color} />
    </svg>
  );
}
